import apiClient from "./config";
import { TRACK_ACTIVITY } from "./endpoints";

const trackActivityService = {
    // Track user activity
    trackActivity: (data) => {
        console.log("📡 Making trackActivity API call with data:", data);
        console.log("📡 API endpoint:", TRACK_ACTIVITY.trackActivity);
        return apiClient.post(TRACK_ACTIVITY.trackActivity, data);
    },
    activityStart: (data) => {
        return apiClient.post(TRACK_ACTIVITY.activityStart, data);
    },
    activityPing: (data) => {
        return apiClient.post(TRACK_ACTIVITY.activityPing, data);
    },
    activityEnd: (data) => {
        return apiClient.post(TRACK_ACTIVITY.activityEnd, data);
    },
    activationTrack: (data) => {
        return apiClient.post(TRACK_ACTIVITY.activationTrack, data);
    },
};

export default trackActivityService;
